import {
  Gallery,
  Data,
  Accessibility,
  Growth,
  Empowerment,
  APIIntegration,
  Fashion,
  GlobalSales,
  API,
  Advantage,
  Geo,
  Marketplace,
  SuccessfulCase,
  Publisher,
  BeyondStyle,
  MerchantsBrands,
  Footer,
  // BrandLaunch,
  AIShopping,
  ShopGeni,
  PriceHunter,
} from "@/modules";
const Home = () => {
  return (
    <>
      <Gallery />
      <Data />
      <Accessibility />
      <Growth />
      <Empowerment />
      <APIIntegration />
      <Fashion />
      <GlobalSales />
      <API />
      <Advantage />
      <Geo />
      <ShopGeni />
      <PriceHunter />
      <AIShopping />
      <Marketplace />
      <SuccessfulCase />
      <Publisher />
      <BeyondStyle />
      <MerchantsBrands />
      {/* <BrandLaunch /> */}
      <Footer />
    </>
  );
};

export default Home;
